/**
 * @module websocket.event.handlers.flights.flight-added
 */
import { store } from '../../../../state/store'
import { setFlightListUpdated } from '../../../../state/websocket.slice'

export default function handleFlightAdded(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleFlightAdded', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setFlightListUpdated(data))
  }
} 